import { FC } from 'react';

import { ImageModalState } from '../utils/delivery.types';

interface Props {
  modal: ImageModalState;
  onClose: () => void;
}

export const ImagePreviewModal: FC<Props> = ({ modal, onClose }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    onClick={onClose}
  >
    <div
      className="relative max-h-[90vh] max-w-[90vw] overflow-auto rounded-lg bg-white"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={onClose}
        className="absolute right-3 top-3 z-10 rounded-full bg-white/80 p-1 text-gray-600 shadow hover:bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div className="border-b bg-gray-50 px-5 py-3">
        <p className="text-sm font-semibold text-gray-900">{modal.itemName}</p>
        <p className="mt-1 text-xs text-gray-600">{modal.address}</p>
        <p className="mt-0.5 text-xs text-gray-500">배송완료: {modal.deliveredAt}</p>
      </div>
      <div className="p-2">
        <img
          src={modal.url}
          alt="배송완료 사진"
          className="max-h-[75vh] max-w-full object-contain"
        />
      </div>
    </div>
  </div>
);
